import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';

class ViewGalleryContainer extends Component {

  constructor(props) {
    super(props);
    
    this.routeChange = this.routeChange.bind(this);
  }

  routeChange() {
    let path = `gallery`;
    this.props.history.push(path);
  }
  render() {
    return (
      <Container fluid={true}>
        <section style={{
            textAlign: 'center'
        }}>
            <h1>
                Take a look in our work
            </h1>
            <br/>
            <button type="button" className="btn btn-primary"
              onClick={this.routeChange}> Visit our gallery
            </button>
        </section>
      </Container>
    );
  }
}

export default withRouter(ViewGalleryContainer);